export const editorOwnedThreeObject = Symbol.for("needle-editor:owned-three-object");

type ConstructorWithPrototype = { prototype: object };

export function markEditorThreePrototype(constructor: ConstructorWithPrototype): void {
    Object.defineProperty(constructor.prototype, editorOwnedThreeObject, {
        value: true,
        configurable: false,
        enumerable: false,
        writable: false,
    });
}
